module.exports = __webpack_public_path__ + "img/City-Link Express.5b46e870.png";